export default "__VITE_ASSET__$Pziswki__"